import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGrit} from "../TrueGrit";
import {TrueGritStatics} from "../TrueGritStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {gsap} from "gsap";
import {TrueGritSymbol} from "../reels/TrueGritSymbol";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {TrueGritSound} from "../sound/TrueGritSound";
import {TrueGritGameMode} from "../server/TrueGritGameMode";

/**
 * Created by Jerker Nord on 2021-07-16.
 */

export class TrueGritSymbolBoxView extends PIXI.Container implements StageLayer {

    private static LOCK_1_POSITIONS:PIXI.Point[] = [new PIXI.Point(4, 3), new PIXI.Point(5, 2),
        new PIXI.Point(5, 3), new PIXI.Point(6, 1), new PIXI.Point(6, 2), new PIXI.Point(6, 3)];
    private static LOCK_3_POSITION:PIXI.Point = new PIXI.Point(6, 4);
    private static REMOVE_BOX_01_POSITIONS:PIXI.Point[] = [new PIXI.Point(3, 4), new PIXI.Point(4, 3), new PIXI.Point(5, 2), new PIXI.Point(6, 1)];
    private static REMOVE_BOX_02_POSITIONS:PIXI.Point[] = [new PIXI.Point(4, 4), new PIXI.Point(5, 3), new PIXI.Point(6, 2)];
    private static REMOVE_BOX_03_POSITIONS:PIXI.Point[] = [new PIXI.Point(5, 4), new PIXI.Point(6, 3)];
    private static REMOVE_BOX_04_POSITIONS:PIXI.Point[] = [new PIXI.Point(6, 4)];
    private static DELAY_BETWEEN_BOX_EXPLOSIONS:number = 0.18;
    private static WILD_LOCK_SHOOTING_POSITION:PIXI.Point = new PIXI.Point(10, -8);

    private _lock01s:PIXI.Sprite[];
    private _lock03Frame:PIXI.Sprite;
    private _lock03FrameLock:PIXI.Sprite;
    private _lock03WildDisabled:PIXI.Sprite;
    private _lock03WildEnabled:PIXI.Sprite;
    private _wildMultiplierTextEnabled:PIXI.BitmapText;
    private _wildMultiplierTextDisabled:PIXI.BitmapText;
    private _lock03Container:PIXI.Container;
    private _removeBoxAnimations:gsap.core.Timeline[];
    private _removeBoxAnimations01:TimelineSprite[];
    private _removeBoxAnimations02:TimelineSprite[];
    private _removeBoxAnimations03:TimelineSprite[];
    private _collapseRemoveBoxAnimations:gsap.core.Timeline[];
    private _locksLevel01:PIXI.Sprite[];
    private _locksLevel02:PIXI.Sprite[];
    private _locksLevel03:PIXI.Sprite[];
    private _allLocksLevels:PIXI.Sprite[][];
    private _currentLockLevel:number = 0;
    private _aborted:boolean = false;
    private _removeWildLockAnimations:TimelineSprite;
    private _wildFrameShineAnimations:TimelineSprite;
    private _wildLockShootingAnimations:TimelineSprite;
    private _restoreLockedWild:boolean = false;

    constructor() {
        super();
        this.name = "TrueGritSymbolBoxView";
        this.init();
    }

    private init() {
        let tempExplosion:TimelineSprite;
        this._removeBoxAnimations01 = [];
        for(let i:number = 0; i < TrueGritSymbolBoxView.REMOVE_BOX_01_POSITIONS.length; i++) {
            tempExplosion = new TimelineSprite(TrueGrit.assetLoader.getTextures("winAnimations/frameExplosion/framexplosion_"));
            tempExplosion.anchor.set(0.5, 0.5);
            tempExplosion.position.set((TrueGritStatics.symbolWidth * TrueGritSymbolBoxView.REMOVE_BOX_01_POSITIONS[i].x) - 18, (TrueGritStatics.symbolHeight * TrueGritSymbolBoxView.REMOVE_BOX_01_POSITIONS[i].y) - 4);
            tempExplosion.visible = false;
            this._removeBoxAnimations01.push(tempExplosion);
            TrueGrit.symbolBoxExplosionView.addChild(tempExplosion);
        }

        this._removeBoxAnimations02 = [];
        for(let i:number = 0; i < TrueGritSymbolBoxView.REMOVE_BOX_02_POSITIONS.length; i++) {
            tempExplosion = new TimelineSprite(TrueGrit.assetLoader.getTextures("winAnimations/frameExplosion/framexplosion_"));
            tempExplosion.anchor.set(0.5, 0.5);
            tempExplosion.position.set((TrueGritStatics.symbolWidth * TrueGritSymbolBoxView.REMOVE_BOX_02_POSITIONS[i].x) - 18, (TrueGritStatics.symbolHeight * TrueGritSymbolBoxView.REMOVE_BOX_02_POSITIONS[i].y) - 4);
            tempExplosion.visible = false;
            this._removeBoxAnimations02.push(tempExplosion);
            TrueGrit.symbolBoxExplosionView.addChild(tempExplosion);
        }

        this._removeBoxAnimations03 = [];
        for(let i:number = 0; i < TrueGritSymbolBoxView.REMOVE_BOX_03_POSITIONS.length; i++) {
            tempExplosion = new TimelineSprite(TrueGrit.assetLoader.getTextures("winAnimations/frameExplosion/framexplosion_"));
            tempExplosion.anchor.set(0.5, 0.5);
            tempExplosion.position.set((TrueGritStatics.symbolWidth * TrueGritSymbolBoxView.REMOVE_BOX_03_POSITIONS[i].x) - 18, (TrueGritStatics.symbolHeight * TrueGritSymbolBoxView.REMOVE_BOX_03_POSITIONS[i].y) - 4);
            tempExplosion.visible = false;
            this._removeBoxAnimations03.push(tempExplosion);
            TrueGrit.symbolBoxExplosionView.addChild(tempExplosion);
        }

        const boxExplosionAnimation:PIXI.Texture[] = TrueGrit.assetLoader.getTextures("winAnimations/frameExplosion/framexplosion_");
        //Push animation to GPU
        for(let i:number = 0; i < boxExplosionAnimation.length; i++) {
            TrueGrit.gpuPushView.addChild(new PIXI.Sprite(boxExplosionAnimation[i]));
        }

        this._collapseRemoveBoxAnimations = [];
        this._collapseRemoveBoxAnimations.push(this._removeBoxAnimations01[0].getAnimationAutoShowHide());
        this._collapseRemoveBoxAnimations.push(this._removeBoxAnimations02[0].getAnimationAutoShowHide());
        this._collapseRemoveBoxAnimations.push(this._removeBoxAnimations03[0].getAnimationAutoShowHide());

        this._lock01s = [];
        let tempLock:PIXI.Sprite;
        for(let i:number = 0; i < TrueGritSymbolBoxView.LOCK_1_POSITIONS.length; i++) {
            tempLock = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("lock1")[0]);
            tempLock.anchor.set(0.5, 0.5);
            tempLock.position.set(TrueGritStatics.symbolWidth * TrueGritSymbolBoxView.LOCK_1_POSITIONS[i].x, (TrueGritStatics.symbolHeight * TrueGritSymbolBoxView.LOCK_1_POSITIONS[i].y) - 4);
            this._lock01s.push(tempLock);
            this.addChild(tempLock);
        }
        this._lock03WildDisabled = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("W/W_disabled")[0]);
        this._lock03WildDisabled.anchor.set(0.5, 0.5);
        this._lock03WildDisabled.position.set(TrueGritStatics.symbolWidth * TrueGritSymbolBoxView.LOCK_3_POSITION.x, TrueGritStatics.symbolHeight * TrueGritSymbolBoxView.LOCK_3_POSITION.y);
        this.addChild(this._lock03WildDisabled);
        this._lock03WildEnabled = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("W/W")[0]);
        this._lock03WildEnabled.anchor.set(0.5, 0.5);
        this._lock03WildEnabled.position.set(TrueGritStatics.symbolWidth * TrueGritSymbolBoxView.LOCK_3_POSITION.x, TrueGritStatics.symbolHeight * TrueGritSymbolBoxView.LOCK_3_POSITION.y);
        this.addChild(this._lock03WildEnabled);

        this._lock03Container = new PIXI.Container();
        this.addChild(this._lock03Container);

        this._allLocksLevels = [];

        this._locksLevel01 = [];
        this._locksLevel01.push(this._lock01s[0]);
        this._locksLevel01.push(this._lock01s[1]);
        this._locksLevel01.push(this._lock01s[3]);
        this._allLocksLevels.push(this._locksLevel01);

        this._locksLevel02 = [];
        this._locksLevel02.push(this._lock01s[2]);
        this._locksLevel02.push(this._lock01s[4]);
        this._allLocksLevels.push(this._locksLevel02);

        this._locksLevel03 = [];
        this._locksLevel03.push(this._lock01s[5]);
        this._allLocksLevels.push(this._locksLevel03);

        this._wildMultiplierTextDisabled = new PIXI.BitmapText("x" + TrueGrit.model.initData.botTrain.wildMult, {
            fontName : TrueGritGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS_DISABLED,
            fontSize : 64
        });
        this._wildMultiplierTextDisabled.anchor = new PIXI.Point(0, 0.5);
        this._wildMultiplierTextDisabled.position.set(-50, 25);
        this._lock03Container.addChild(this._wildMultiplierTextDisabled);
        this._wildMultiplierTextEnabled = new PIXI.BitmapText("x" + TrueGrit.model.initData.botTrain.wildMult, {
            fontName : TrueGritGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS_ENABLED,
            fontSize : 64
        });
        this._wildMultiplierTextEnabled.anchor = new PIXI.Point(0, 0.5);
        this._wildMultiplierTextEnabled.position.set(-50, 25);
        this._lock03Container.addChild(this._wildMultiplierTextEnabled);

        this._lock03FrameLock = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("Wlock3")[0]);
        this._lock03FrameLock.anchor.set(0.5, 0.5);
        this._lock03Container.addChild(this._lock03FrameLock);

        const removeWildLockTextures:PIXI.Texture[] = TrueGrit.assetLoader.getTextures("winAnimations/Wlock3Break/Wlock3Break_");
        this._removeWildLockAnimations = new TimelineSprite(removeWildLockTextures);
        this._removeWildLockAnimations.anchor.set(0.5, 0.5);
        this._removeWildLockAnimations.alpha = 0;
        this._lock03Container.addChild(this._removeWildLockAnimations);
        //Push animation to GPU
        for(let i:number = 0; i < removeWildLockTextures.length; i++) {
            TrueGrit.gpuPushView.addChild(new PIXI.Sprite(removeWildLockTextures[i]));
        }

        this._lock03Frame = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("Wframe3")[0]);
        this._lock03Frame.anchor.set(0.5, 0.5);
        this._lock03Container.addChild(this._lock03Frame);

        const wildShineTextures:PIXI.Texture[] = TrueGrit.assetLoader.getTextures("winAnimations/Wframe3Shine/Wframe3Shine_");
        this._wildFrameShineAnimations = new TimelineSprite(wildShineTextures);
        this._wildFrameShineAnimations.anchor.set(0.5, 0.5);
        this._wildFrameShineAnimations.visible = false;
        this._lock03Container.addChild(this._wildFrameShineAnimations);
        //Push animation to GPU
        for(let i:number = 0; i < wildShineTextures.length; i++) {
            TrueGrit.gpuPushView.addChild(new PIXI.Sprite(wildShineTextures[i]));
        }

        const wildLockShootingTextures:PIXI.Texture[] = TrueGrit.assetLoader.getTextures("winAnimations/Wlock3Shots/Wframe3Shots_");
        this._wildLockShootingAnimations = new TimelineSprite(wildLockShootingTextures);
        this._wildLockShootingAnimations.anchor.set(0.5, 0.5);
        this._wildLockShootingAnimations.position = TrueGritSymbolBoxView.WILD_LOCK_SHOOTING_POSITION;
        this._wildLockShootingAnimations.visible = false;
        this._lock03Container.addChild(this._wildLockShootingAnimations);
        //Push animation to GPU
        for(let i:number = 0; i < wildShineTextures.length; i++) {
            TrueGrit.gpuPushView.addChild(new PIXI.Sprite(wildLockShootingTextures[i]));
        }

        this._lock03Container.position.set(TrueGritStatics.symbolWidth * TrueGritSymbolBoxView.LOCK_3_POSITION.x, TrueGritStatics.symbolHeight * TrueGritSymbolBoxView.LOCK_3_POSITION.y);

        this.createRemoveBoxTLs();

        if(TrueGrit.model.isRestore == true) {
            let restoreBoxLevel:number = 0;
            for(let i:number = 0; i < TrueGrit.model.initData.botTrain.isRevealed.length; i++) {
                if(TrueGrit.model.initData.botTrain.isRevealed[i] == true) {
                    restoreBoxLevel++;
                }
            }
            this.setRestoreBoxes(restoreBoxLevel);
        }

        this.setWildMultiplierState();

        this.onResize();
    }

    public setRestoreBoxes(level:number):void {
        this._currentLockLevel = level;
        if(level > this._allLocksLevels.length) {
            level--;
        }
        for(let i:number = 0; i < level; i++) {
            for(let j:number = 0; j < this._allLocksLevels[i].length; j++) {
                this._allLocksLevels[i][j].visible = false;
            }
        }
    }

    private createRemoveBoxTLs():void {
        this._removeBoxAnimations = [];
        let mainRemoveBoxTimeline:gsap.core.Timeline = new gsap.core.Timeline({paused : true, delay : 0.38});
        let subRemoveBoxTimelines:gsap.core.Timeline[] = [];
        let subRemoveBoxTimeline:gsap.core.Timeline;
        for(let i:number = 0; i < this._removeBoxAnimations01.length; i++) {
            subRemoveBoxTimeline = new gsap.core.Timeline({delay : ((TrueGritSymbolBoxView.DELAY_BETWEEN_BOX_EXPLOSIONS) * i)});
            subRemoveBoxTimeline.add(() => this.checkIfAborted());
            subRemoveBoxTimeline.add([
                this._removeBoxAnimations01[i].getAnimationAutoShowHide(),
                () => TrueGrit.soundPlayer.playRandomBoxExplosionSound()
            ]);
            if(i == 0) {
                subRemoveBoxTimeline.add(() => (<TrueGritSymbol>TrueGrit.bottomReelView.getSymbolBySymbolPosition(1)).removeTopChild(), "-=0.6");
                subRemoveBoxTimeline.add(() => (<TrueGritSymbol>TrueGrit.bottomReelView.getSymbolBySymbolPosition(1)).hideSymbol(false), "-=0.6");
                subRemoveBoxTimeline.add(() => TrueGrit.bottomReelView.startHotZoneAnimation(0));
            } else {
                subRemoveBoxTimeline.add(() => {this._locksLevel01[i - 1].visible = false}, "-=0.6");
            }
            subRemoveBoxTimelines.push(subRemoveBoxTimeline);
        }
        mainRemoveBoxTimeline.add(subRemoveBoxTimelines);
        this._removeBoxAnimations.push(mainRemoveBoxTimeline);

        mainRemoveBoxTimeline = new gsap.core.Timeline({paused : true, delay : 0.38});
        subRemoveBoxTimelines = [];
        for(let i:number = 0; i < this._removeBoxAnimations02.length; i++) {
            subRemoveBoxTimeline = new gsap.core.Timeline({delay : ((TrueGritSymbolBoxView.DELAY_BETWEEN_BOX_EXPLOSIONS) * i)});
            subRemoveBoxTimeline.add(() => this.checkIfAborted());
            subRemoveBoxTimeline.add([
                this._removeBoxAnimations02[i].getAnimationAutoShowHide(),
                () => TrueGrit.soundPlayer.playRandomBoxExplosionSound()
            ]);
            if(i == 0) {
                subRemoveBoxTimeline.add(() => (<TrueGritSymbol>TrueGrit.bottomReelView.getSymbolBySymbolPosition(2)).removeTopChild(), "-=0.6");
                subRemoveBoxTimeline.add(() => (<TrueGritSymbol>TrueGrit.bottomReelView.getSymbolBySymbolPosition(2)).hideSymbol(false), "-=0.6");
                subRemoveBoxTimeline.add(() => TrueGrit.bottomReelView.startHotZoneAnimation(1)); // #334, #329
            } else {
                subRemoveBoxTimeline.add(() => {this._locksLevel02[i - 1].visible = false}, "-=0.6");
            }
            subRemoveBoxTimelines.push(subRemoveBoxTimeline);
        }
        mainRemoveBoxTimeline.add(subRemoveBoxTimelines);
        this._removeBoxAnimations.push(mainRemoveBoxTimeline);

        mainRemoveBoxTimeline = new gsap.core.Timeline({paused : true, delay : 0.38});
        subRemoveBoxTimelines = [];
        for(let i:number = 0; i < this._removeBoxAnimations03.length; i++) {
            subRemoveBoxTimeline = new gsap.core.Timeline({delay : ((TrueGritSymbolBoxView.DELAY_BETWEEN_BOX_EXPLOSIONS) * i)});
            subRemoveBoxTimeline.add(() => this.checkIfAborted());
            subRemoveBoxTimeline.add([
                this._removeBoxAnimations03[i].getAnimationAutoShowHide(),
                () => TrueGrit.soundPlayer.playRandomBoxExplosionSound()
            ]);
            if(i == 0) {
                subRemoveBoxTimeline.add(() => (<TrueGritSymbol>TrueGrit.bottomReelView.getSymbolBySymbolPosition(3)).removeTopChild(), "-=0.6");
                subRemoveBoxTimeline.add(() => (<TrueGritSymbol>TrueGrit.bottomReelView.getSymbolBySymbolPosition(3)).hideSymbol(false), "-=0.6");
                subRemoveBoxTimeline.add(() => TrueGrit.bottomReelView.startHotZoneAnimation(2));
            } else {
                subRemoveBoxTimeline.add(() => {this._locksLevel03[i - 1].visible = false}, "-=0.6");
            }
            subRemoveBoxTimelines.push(subRemoveBoxTimeline);
        }
        mainRemoveBoxTimeline.add(subRemoveBoxTimelines);
        this._removeBoxAnimations.push(mainRemoveBoxTimeline);

        let removeWildBoxAnimation:gsap.core.Timeline = new gsap.core.Timeline({paused : true});
        removeWildBoxAnimation.add([
            () => {
                this._wildFrameShineAnimations.alpha = 0;
                    this._wildFrameShineAnimations.visible = true;
                    this._removeWildLockAnimations.alpha = 0;
                    this._removeWildLockAnimations.visible = true;
                    this._lock03WildEnabled.alpha = 0;
                    this._lock03WildEnabled.visible = true;
            },
            gsap.to(this._wildFrameShineAnimations, {duration : 0.2, alpha : 1}),
            gsap.to(this._removeWildLockAnimations, {duration : 0.2, alpha : 1})
        ]);
        removeWildBoxAnimation.add([
            () => {this._wildLockShootingAnimations.alpha = 1},
            () => this._wildLockShootingAnimations.visible = true,
            () => TrueGrit.soundPlayer.playSound(TrueGritSound.GUN_BOX_WILD_SOUND_1),
            this._wildLockShootingAnimations.getAnimation([0, 7])
        ], "+=0.1");
        removeWildBoxAnimation.add([
            () => {TrueGrit.soundPlayer.playSound(TrueGritSound.GUN_BOX_WILD_SOUND_2)},
            this._wildLockShootingAnimations.getAnimation([8, 16])
        ]);
        removeWildBoxAnimation.add([
            () => {TrueGrit.soundPlayer.playSound(TrueGritSound.GUN_BOX_WILD_SOUND_3)},
            this._wildLockShootingAnimations.getAnimation([17, 25])
        ]);
        removeWildBoxAnimation.add([
            () => {TrueGrit.soundPlayer.playSound(TrueGritSound.GUN_BOX_WILD_SOUND_4)},
            this._wildLockShootingAnimations.getAnimation([26, 41])
        ]);
        removeWildBoxAnimation.add([
            () => {this._lock03Frame.visible = false},
            () => {this._lock03FrameLock.visible = false}
        ], "-=0.4");
        removeWildBoxAnimation.add(this._removeWildLockAnimations.getAnimationAutoShowHide(), "-=0.4");
        removeWildBoxAnimation.add([
            this._wildFrameShineAnimations.getAnimation().play(),
            () => {this._lock03WildEnabled.alpha = 0},
            () => {this._lock03WildEnabled.visible = true},
            () => {this._wildMultiplierTextEnabled.alpha = 0},
            () => {this._wildMultiplierTextEnabled.visible = true},
            gsap.to(this._lock03WildEnabled, {duration : 0.3, alpha : 1, delay : 0.2}),
            gsap.to(this._wildMultiplierTextDisabled, {duration : 0.2, alpha : 0, delay : 0.3}),
            gsap.to(this._wildMultiplierTextEnabled, {duration : 0.3, alpha : 1, delay : 0.2})
        ], "-=0.8");
        removeWildBoxAnimation.add([
            () => {this._lock03WildDisabled.visible = false},
            () => {this._wildMultiplierTextDisabled.visible = false}
        ]);

        this._removeBoxAnimations.push(removeWildBoxAnimation);
    }

    private checkIfAborted():void {
        if(this._aborted == true) {
            this._aborted = false;
            for(let i:number = 0; i < this._removeBoxAnimations.length; i++) {
                if(this._removeBoxAnimations[i].isActive()) {
                    this._removeBoxAnimations[i].pause();
                    this._removeBoxAnimations[i].kill();
                }
            }
        }
    }

    onResize():void {
        this.position = TrueGritStatics.SYMBOL_BOX_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }

    public restoreAllBoxes():void {
        if(this._currentLockLevel > 0) {
            for(let i:number = 0; i < this._lock01s.length; i++) {
                this._lock01s[i].visible = true;
            }
            TrueGrit.bottomReelView.restoreAllBoxes();
            this._lock03Frame.visible = true;
            this._currentLockLevel = 0;
        }
    }

    public getCollapsedReelRemoveBoxAnimation(position:number):gsap.core.Timeline {
        return this._collapseRemoveBoxAnimations[position - 1].restart();
    }

    public getRemoveBoxAnimation():gsap.core.Timeline {
        // #337 -> if restore is done in FS, then this._currentLockLevel becomes 0 and hence the bug.
        if (TrueGrit.model.data.mode.indexOf(TrueGritGameMode.FREESPIN) > -1) {
            this._currentLockLevel = 3;
        }

        this._currentLockLevel++;
        return this._removeBoxAnimations[(this._currentLockLevel - 1)];
    }

    public setWildMultiplierText(multiplierText:string, isStickyWildWinning: boolean = false):void {
        if(multiplierText == this._wildMultiplierTextEnabled.text) {
            return;
        }
        const tl = gsap.timeline();
        const duration: number = 0.1;
        const stayDelay: number = isStickyWildWinning ? 0.4 : 0;
        let toScale: number;

        // #133 -> try to make sure multiplier doesn't go out of the symbol boundaries
        if (multiplierText.length > 3) {
            toScale = 1.05;
        } else if (multiplierText.length > 2) {
            if (isStickyWildWinning) {
                toScale = 1.27;
            } else {
                toScale = 1.2;
            }
        } else {
            if (isStickyWildWinning) {
                toScale = 1.75;
            } else {
                toScale = 1.2;
            }
        }

        tl.add(() => {
            this._wildMultiplierTextEnabled.text = multiplierText;
            this._wildMultiplierTextDisabled.text = multiplierText;
        });
        tl.add(gsap.to(this._wildMultiplierTextEnabled.scale, {duration:duration, x : toScale, y : toScale, ease:"back.out(2.7)"}));
        if (isStickyWildWinning){
            tl.add(this.getWildShineAnimation(), "<");
        }
        tl.add(gsap.to(this, {duration:stayDelay}));

        if (!isStickyWildWinning) {
            tl.add(this.scaleOutStickyWildMultiplierText());
        }
    }

    // #133
    public scaleOutStickyWildMultiplierText(): gsap.core.Tween {
        return gsap.to(this._wildMultiplierTextEnabled.scale, {duration: 0.1, x: 1.0, y: 1.0, ease: "back.out(0.7)"});
    }

    public setWildMultiplierState():void {
        if(this._restoreLockedWild == true) {
            this._restoreLockedWild = false;
            this.setMainGameWild();
            return;
        }
        if(TrueGrit.model.data.botTrain.isRevealed[3] == true) {
            this._wildFrameShineAnimations.alpha = 1;
            this._wildFrameShineAnimations.visible = true;
            this._lock03Frame.visible = false;
            this._lock03FrameLock.visible = false;
            this._lock03WildEnabled.alpha = 1;
            this._lock03WildEnabled.visible = true;
            this._lock03WildDisabled.alpha = 0;
            this._wildMultiplierTextEnabled.visible = true;
            this._wildMultiplierTextEnabled.alpha = 1;
            this._wildMultiplierTextDisabled.alpha = 0;
        } else {
            this.setMainGameWild();
        }
    }

    private setMainGameWild():void {
        this._wildFrameShineAnimations.visible = false;
        this._lock03Frame.alpha = 1;
        this._lock03Frame.visible = true;
        this._lock03FrameLock.alpha = 1;
        this._lock03FrameLock.visible = true;
        this._lock03WildEnabled.alpha = 0;
        this._lock03WildDisabled.alpha = 1;
        this._lock03WildDisabled.visible = true;
        this._wildMultiplierTextEnabled.alpha = 0;
        this._wildMultiplierTextDisabled.alpha = 1;
        this._wildMultiplierTextDisabled.visible = true;
    }

    set currentLockLevel(value:number) {
        this._currentLockLevel = value;
    }

    set restoreLockedWild(value:boolean) {
        this._restoreLockedWild = value;
    }

    set aborted(value:boolean) {
        //this._aborted = value;
    }

    getWildShineAnimation() {
        return this._wildFrameShineAnimations.getAnimation();
    }
}